/**
 * @class away.pool.RenderablePool
 */
var RenderablePool = (function () {
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderablePool(entity, materialGroup) {
        this._abstractionPool = new Object();
        this._entity = entity;
        this._materialGroup = materialGroup;
    }
    Object.defineProperty(RenderablePool.prototype, "entity", {
        /**
         *
         * @returns {IEntity}
         */
        get: function () {
            return this._entity;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderablePool.prototype, "materialGroup", {
        /**
         *
         * @returns {MaterialGroupBase}
         */
        get: function () {
            return this._materialGroup;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * //TODO
     *
     * @param renderable
     * @returns GL_RenderableBase
     */
    RenderablePool.prototype.getAbstraction = function (renderable) {
        return this._abstractionPool[renderable.id] || (this._abstractionPool[renderable.id] = new RenderablePool._abstractionClassPool[renderable.assetType](renderable, this));
    };
    /**
     *
     * @param renderable
     */
    RenderablePool.prototype.clearAbstraction = function (renderable) {
        this._abstractionPool[renderable.id] = null;
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderablePool.registerAbstraction = function (renderableClass, assetClass) {
        RenderablePool._abstractionClassPool[assetClass.assetType] = renderableClass;
    };
    return RenderablePool;
}());
export { RenderablePool };
RenderablePool._abstractionClassPool = new Object();



// WEBPACK FOOTER //
// ../dist/lib/renderables/RenderablePool.js